import BigNumber from 'bignumber.js'

export const BIG_ZERO = new BigNumber(0)
export const bigIntToBigNumber = (bigint) => new BigNumber(bigint.toString())
